module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Set sail on the high seas with this collection of twenty-one unforgettable short stories featuring dashing rogues, daring rebels, and wily pirates searching for treasures of all kinds, including a forgotten journal, a heavenly sword, a young girl’s lucky sock, and even the Fountain of Youth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Some pirates are familiar—complete with parrots, peg legs, and eye patches—but most are unique: a twelve-year-old computer hacker, a heroic rabbit on an unusual quest, a clump of cancer cells, and an alien setting sail among the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("X Marks the Spot: An Anthology of Treasure and Theft")]), _vm._v(" is about those men and women who live on the fringes of society, who are beholden to no man, no law, and who always have one eye on the horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("So grab your map and set your headings. There are adventures to be had, mateys, and treasures to be found.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This anthology is the fifth volume produced by the alumni of the Superstars Writing Seminars, and all royalties benefit the Don Hodge Memorial Scholarship Fund.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0